








































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientScope } from "@/types/client";

@Component
export default class ClientScopeDashboard extends Vue {
  scopeId: string = "";
  httpService = new HttpService<ClientScope>();
  responseArray = new Array<ClientScope>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientScope();
  async getList() {
    let httpService = new HttpService<Array<ClientScope>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/scopes`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(scope: ClientScope) {
    this.$router.push({
      name: "clientScopeEdit",
      params: {
        id: this.clientId,
        scopeId: scope.id
      }
    });
  }

  confirmRemove(data: ClientScope) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientScope) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/scopes`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientScope) => item.clientId != data.clientId,
      this.$notification.success(`${data.scope} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
